import React, { lazy, Suspense } from 'react';
import { Container } from 'components/UI';
import { Title, Loader } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';
import { isPastMeetup } from 'utils';

import * as styles from './ContactUs.module.scss';

const CorporateForm = lazy(() => import('../CorporateForm'));

export default function ContactUs({ title, meetupDate }) {
  const isSsr = useIsSsr();

  if (isPastMeetup(meetupDate)) {
    return null;
  }

  return (
    <Container id="contactUs" className={styles.container} background="transparent">
      <div className={styles.layout}>
        <div className={styles.content}>
          <Title className={styles.title} color="white">
            {title}
          </Title>
        </div>
        <div className={styles.formWrapper}>
          {!isSsr && (
            <Suspense fallback={<Loader theme="fullHeight" />}>
              <CorporateForm className={styles.form} captchaInfo={true} />
            </Suspense>
          )}
        </div>
      </div>
    </Container>
  );
}
